import { ButtonGroup } from '~/shared/forms/controls/base-controls/ButtonGroup';
import { NewGoalSearch } from './NewGoalSearch';
import { SuggestedGoals } from './SuggestedGoals';
import { CustomGoalForm } from './CustomGoalForm';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import type { SelectedGoalOption } from '../reducer/wizardReducer';
import { ExistingGoals } from './ExistingGoals';

const goalSelectionOptions = [
	{ id: 'suggested', label: 'Suggested' },
	{ id: 'new', label: 'New' },
	{ id: 'existing', label: 'Existing' },
	{ id: 'custom', label: 'Custom' }
];

export function SelectGoalStep() {
	const { wizardState, existingGoals, suggestedGoalsAndInterventions, dispatch } = useGoalsAndInterventionsWizard();
	return (
		<div className="flex flex-col gap-4">
			<ButtonGroup
				options={goalSelectionOptions
					.filter(x => {
						if (x.id === 'suggested') {
							return suggestedGoalsAndInterventions && suggestedGoalsAndInterventions.length > 0;
						} else if (x.id === 'existing') {
							return existingGoals.length > 0;
						}
						return true;
					})
					.map(x => ({
						...x,
						label:
							x.id === 'suggested'
								? `${x.label} (${suggestedGoalsAndInterventions!.length})`
								: x.id === 'existing'
								? `${x.label} (${existingGoals.length})`
								: x.label
					}))}
				isSelected={(id: string) => wizardState.selectedGoalOption === id}
				onSelect={(id: string) => dispatch({ type: 'GOAL_OPTION_CHANGED', option: id as SelectedGoalOption })}
			/>
			{wizardState.selectedGoalOption === 'new' ? (
				<NewGoalSearch />
			) : wizardState.selectedGoalOption === 'suggested' ? (
				<SuggestedGoals />
			) : wizardState.selectedGoalOption === 'custom' ? (
				<CustomGoalForm />
			) : (
				<ExistingGoals />
			)}
		</div>
	);
}
